import React, { useEffect, useMemo, useState } from "react";

const TreatmentTabs = ({ handlePage, tabsData, height, labelClass = "", forPage = "" }) => {
  // Dynamically generate styles for each tab

  const [activeTab, setActiveTab] = useState("treatment");
  useEffect(() => {
    if (handlePage === "detail" && forPage !== "Defendants" && forPage !== "Insurance") {
      setActiveTab("treatment");
    } else {
      setActiveTab(handlePage);
    }
  }, [handlePage]);

  const handleTabClick = (tabId) => {
    if (tabId !== "newProvider" && tabId !== "treatmentDates") {
      setActiveTab(tabId);
      const tab = tabsData.find((tab) => tab.id === tabId);
      tab.onClick();
    } else {
      const tab = tabsData.find((tab) => tab.id === tabId);
      tab.onClick();
    }
  };
  const tabStyles = useMemo(() => {
    return tabsData.reduce((styles, tab) => {
      const color = tab.background;
      const hoverColor = tab.hoverColor || "var(--primary)";
      styles += `
        .tab-${tab.id}::before {
          border-bottom: ${height}px solid ${color};
        }
        .tab-${tab.id}::after {
          border-bottom: ${height}px solid ${color};
        }
          .tab-${tab.id}:hover::before {
          border-bottom: ${height}px solid ${hoverColor};
        }
        .tab-${tab.id}:hover::after {
          border-bottom: ${height}px solid ${hoverColor};
        }
             .tab-${tab.id}:active::before,
        .tab-${tab.id}.active::before {
          border-bottom: ${height}px solid ${hoverColor};
        }
        .tab-${tab.id}:active::after,
        .tab-${tab.id}.active::after {
          border-bottom: ${height}px solid ${hoverColor};
        }
        
        .tab-summary:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }

         .tab-simple:active,
        .tab-simple.active {
          z-index: 13 !important;
            background-color: ${hoverColor} !important;
        }
          
        .tab-summary:active,
        .tab-summary.active {
          z-index: 10 !important;
          color: ${tab.hoverColor};
        }

        .tab-treatment:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
             .tab-detail:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }

         .tab-insurance-add:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }

          .tab-detail:active,
        .tab-detail.active {
          z-index: 10 !important;
          color: ${tab.hoverColor};
        }
          
        .tab-treatment:active,
        .tab-treatment.active {
          z-index: 10 !important;
          color: ${tab.hoverColor};
        }

        .tab-dates:hover{
          z-index: 10 !important;
          background-color: ${hoverColor} !important;
        }
        .tab-dates:active,
        .tab-dates.active {
          z-index: 10 !important;
          color: ${tab.hoverColor};
        }
        .tab-newProvider:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
            .tab-add-report:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }

        .tab-witness-add:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
        .tab-simple:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
             .tab-defendant-add:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
            .tab-photo:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
        .tab-newProvider:active,
        .tab-newProvider.active {
          z-index: 10 !important;
          color: ${tab.hoverColor};
        }
          .tab-treatmentDates:active,
        .tab-treatmentDates.active {
          z-index: 10 !important;
          color: ${tab.hoverColor};
        }
           .tab-treatmentDates:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
               .tab-new-client-on-case:active,
        .tab-new-client-on-case.active {
          z-index: 10 !important;
          color: ${tab.hoverColor};
        }
           .tab-new-client-on-case:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
                .tab-new-co-counseling-firm:active,
        .tab-new-co-counseling-firm.active {
          z-index: 10 !important;
          color: ${tab.hoverColor};
        }
           .tab-new-co-counseling-firm:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }

          .tab-litigation_act:active,
        .tab-litigation_act.active {
          z-index: 10 !important;
          color: ${tab.hoverColor};
        }
           .tab-litigation_act:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }

        .tab-checks:active,
        .tab-checks.active {
          z-index: 10 !important;
          color: ${tab.hoverColor};
        }
           .tab-checks:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }

        .tab-trust_led:active,
        .tab-trust_led.active {
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
           .tab-trust_led:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }

          .tab-accidentTimelineAdd:active,
        .tab-accidentTimelineAdd.active {
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
           .tab-accidentTimelineAdd:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }

          .tab-propertyDamageAdd:active,
        .tab-propertyDamageAdd.active {
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
           .tab-propertyDamageAdd:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }

         .tab-duration:active,
        .tab-duration.active {
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
           .tab-duration:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }

         .tab-values:active,
        .tab-values.active {
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
           .tab-values:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }

          .tab-expanded:active,
        .tab-expanded.active {
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
           .tab-expanded:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }

         .tab-recording:active,
        .tab-recording.active {
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
           .tab-recording:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
.tab-save:active,
        .tab-save.active {
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }
         
           .tab-save:hover{
          z-index: 10 !important;
            background-color: ${hoverColor} !important;
        }

        .tab-${tab.id}:active,
        .tab-${tab.id}.active {
          color: ${tab.hoverColor};
        }
      
        .tab-${tab.id}:hover {
          background-color: ${hoverColor};
        }

        .tab-${tab.id}{
          color: ${tab.color};
        }
        .tab-newProvider{
          padding-left: 5px !important;
        }
           .tab-treatmentDates{
          padding-left: 5px !important;
        }
        
      `;
      return styles;
    }, "");
  }, [tabsData, height]);
  const paddedTabs = ["Summary", "Simple", "Detail", "Trust Ledger", "Checks"];

  return (
    <>
      <style>{tabStyles}</style>

      <div className={`continuous-tabs  ${labelClass}`}>
        {tabsData.map((tab, index) => (
          <button
            id={tab.id}
            key={index}
            onClick={() => handleTabClick(tab.id)}
            className={`tab-defendant-page tab-trapezium-cycles-corners tab-${tab.id} d-flex align-items-center justify-content-center ${
              activeTab === tab.id ? "active" : ""
            }`}
            style={{
              background: tab.background,
              zIndex: tabsData.length - index,
              left: tab.left,
              paddingLeft: "5px",
              paddingRight: paddedTabs.includes(tab?.label) ? "9px" : "5px",
            }}
          >
            {tab.leftHand && tab.span}
            <span className="tab-label">{tab.label}</span>
            {tab.rightHand && tab.span}
          </button>
        ))}
      </div>
    </>
  );
};

export default React.memo(TreatmentTabs);
